import { render, staticRenderFns } from "./FileUploadPanel.vue?vue&type=template&id=b5931822&scoped=true&"
import script from "./FileUploadPanel.vue?vue&type=script&lang=js&"
export * from "./FileUploadPanel.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadPanel.vue?vue&type=style&index=0&id=b5931822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5931822",
  null
  
)

export default component.exports